/**
 * The registered tool name for the agent's "ask a human" approval.
 *
 * DECLARED HERE RATHER THAN BESIDE THE CARD THAT RENDERS IT, and the reason is a
 * zone rule rather than tidiness. `ApprovalRequestBlock.display.tsx` builds the
 * card's subtitle and lives in `/ui`; `approval-note-opt-in.ts` is a set membership
 * test over two tool names, renders nothing, and therefore belongs in `/data` — and
 * a `/data` module may not reach a `/ui` zone (`manifest-boundary.test.ts`, rule 3).
 * One constant read from two zones has to sit below both.
 *
 * `ApprovalRequestBlock.display.tsx` re-exports the name, so its own export surface
 * is unchanged and every consumer of that path keeps working.
 *
 * ITS SIBLING IS ALREADY IN A HEADLESS ZONE. `EMAIL_SESSION_CONTENT_TOOL_NAME`, the
 * other member of the opt-in set, lives in `data/projects/components/ApprovalRequestBlock.multiplayer.ts`
 * — it was never in a rendering module, so nothing had to move for it. This file is
 * what makes the pair reachable from one place.
 */
export const REQUEST_HUMAN_APPROVAL_TOOL_NAME = 'request_human_approval';
